<div class="flex flex-col">
  <!-- Policy -->
  <div>
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "generalOptions.title" | translate }}
    </span>
  </div>
  <!-- Civility -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Civilite)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.civility" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-dropdown
          [options]="civilityOptions"
          [(ngModel)]="memberCopy.civilityId"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Civilite, hasEndorsementWait4Sign)
          "
          [styleClass]="
            getDropdownClass(
              civilityHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Civilite, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onCivilityHasChanged()"
          optionValue="value"
          optionLabel="label"></p-dropdown>
      </div>
    </div>
  </div>
  <!-- Firstname -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.FirstName)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.firstName" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.firstName"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.FirstName, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              firstNameHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.FirstName, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onFirstNameHasChanged()"
          [placeholder]="'generalOptions.placeholder' | translate" />
        <span
          *ngIf="!isFirstnameValid"
          class="error-message">
          {{ "common.invalidChar" | translate }}
        </span>
      </div>
    </div>
  </div>
  <!-- Lastname -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.LastName)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.lastName" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.lastName"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.LastName, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              lastNameHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.LastName, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onLastNameHasChanged()" />
        <span
          *ngIf="!isLastnameValid"
          class="error-message">
          {{ "common.invalidChar" | translate }}
        </span>
      </div>
    </div>
  </div>
  <!-- Birthdate -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthDate)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.birthDate" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-calendar
          [(ngModel)]="memberCopy.birthDate"
          [placeholder]="'scholarInsurance.birthDatePlaceholder' | translate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthDate, hasEndorsementWait4Sign)
          "
          [ngClass]="
            getCalendarClass(
              memberBirthDateHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthDate, hasEndorsementWait4Sign),
              this.memberCopy.birthDate !== null
            ) + ' w-full'
          "
          styleClass="w-full"
          [minDate]="minTerminationDate"
          [maxDate]="maxTerminationDate"
          (ngModelChange)="onMemberBirthDateChange($event)">
        </p-calendar>
        <span
          *ngIf="isDateInvalid()"
          class="error-message">
          {{ "scholarInsurance.dateError" | translate }}
        </span>
      </div>
    </div>
  </div>

  <!-- BirthCity -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCity)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.cityOfBirth" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.birthCity"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCity, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              birthCityHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCity, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onBirthCityHasChanged()" />
      </div>
    </div>
  </div>

  <!-- Birth Postal Code -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthZipCode)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.birthPostalCode" | translate }}
      </span>
    </div>
    <div class="flex justify-content-center items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.birthZipCode"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthZipCode, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              birthZipCodeHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthZipCode, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onBirthZipCodeHasChanged()" />
      </div>
    </div>
  </div>

  <!-- BirthCountry-->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCountry)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.countryOfBirth" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-dropdown
          [options]="countriesOptions"
          [(ngModel)]="memberCopy.birthCountry"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCountry, hasEndorsementWait4Sign)
          "
          [styleClass]="
            getDropdownClass(
              birthCountryHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.BirthCountry, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onBirthCountryHasChanged()"
          optionValue="countryNameFr"
          optionLabel="countryNameFr"></p-dropdown>
      </div>
    </div>
  </div>
  <!-- Email -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Email)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.email" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.email"
          [disabled]="!getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Email, hasEndorsementWait4Sign)"
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              emailHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Email, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onEmailHasChanged()" />
      </div>
    </div>
  </div>
  <!-- Phone Number -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.PhoneNumber)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.phoneNumber" | translate }}
      </span>
    </div>
    <div class="flex items-center justify-end w-full p-1 overflow-hidden">
      <div class="w-full sm:ml-auto flex flex-col sm:flex-row items-start sm:items-center justify-end">
        <p-dropdown
          [options]="phonePrefixes"
          [(ngModel)]="selectedPhonePrefix"
          appendTo="body"
          optionLabel="prefix"
          class="w-full sm:w-auto mb-2 sm:mb-0"
          [ngClass]="phonePrefixHasChanged ? 'half-dropdown-changed' : 'half-dropdown'"
          (ngModelChange)="onPhonePrefixChange($event)">
          <ng-template
            let-phonePrefixes
            pTemplate="item">
            <div class="flex justify-between items-center font-bold">
              <div class="mr-4">{{ phonePrefixes.region }}</div>
              <div>{{ phonePrefixes.prefix }}</div>
            </div>
          </ng-template>
        </p-dropdown>
        <span class="p-float-label ml-0 sm:ml-2 w-full sm:w-auto">
          <p-inputMask
            type="text"
            [(ngModel)]="memberCopy.phoneNumber"
            [placeholder]="phonePattern"
            pattern="[0-9]*"
            pKeyFilter="int"
            [autoClear]="false"
            [unmask]="true"
            [mask]="phoneMask"
            class="custom-inputmask"
            [ngClass]="
              getInputMaskClass(
                phoneNumberHasChanged,
                getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.PhoneNumber, hasEndorsementWait4Sign),
                isPhoneNumberValid
              )
            "
            (ngModelChange)="onPhoneNumberHasChanged()">
          </p-inputMask>
        </span>
      </div>
    </div>
  </div>
  <!-- Nationality -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Nationality)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.nationality" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-dropdown
          [options]="countriesOptions"
          [(ngModel)]="memberCopy.nationality"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Nationality, hasEndorsementWait4Sign)
          "
          [styleClass]="
            getDropdownClass(
              nationalityHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Nationality, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onNationalityHasChange()"
          optionValue="countryNameFr"
          optionLabel="countryNameFr"></p-dropdown>
      </div>
    </div>
  </div>

  <!--Adresse de contact-->
  <div class="pt-12">
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "userInfo.addressTitle" | translate }}
    </span>
  </div>
  <!-- Address -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address1)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.address" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.address1"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address1, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              address1HasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address1, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onAddress1HasChanged()" />
      </div>
    </div>
  </div>
  <!-- Complement Address -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address2)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.address2" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.address2"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address2, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              address2HasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address2, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="
            getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.Address2, hasEndorsementWait4Sign)
              ? ('generalOptions.placeholder' | translate)
              : ''
          "
          (ngModelChange)="onAddress2HasChanged()" />
      </div>
    </div>
  </div>
  <!-- Postal Code -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.ZipCode)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.postalCode" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.zipCode"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.ZipCode, hasEndorsementWait4Sign)
          "
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              zipCodeHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.ZipCode, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onZipCodeHasChanged()" />
      </div>
    </div>
  </div>
  <!-- City -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.City)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "housingSection.city" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <input
          [(ngModel)]="memberCopy.addressCity"
          [disabled]="!getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.City, hasEndorsementWait4Sign)"
          pInputText
          type="text"
          [ngClass]="
            getInputClass(
              cityHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.City, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          [placeholder]="'generalOptions.placeholder' | translate"
          (ngModelChange)="onCityHasChanged()" />
      </div>
    </div>
  </div>

  <!-- Consentement -->
  <div class="pt-12">
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "userInfo.consentTitle" | translate }}
    </span>
  </div>
  <!-- Email -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsEmailConsents)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.emailConsent" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-dropdown
          [options]="yesNoValues"
          [(ngModel)]="memberCopy.isEmailConsents"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsEmailConsents, hasEndorsementWait4Sign)
          "
          [styleClass]="
            getDropdownClass(
              emailConsentHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsEmailConsents, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onEmailConsentHasChanged()"></p-dropdown>
      </div>
    </div>
  </div>
  <!-- SMS -->
  <div
    *ngIf="getIsVisible(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsSmsConsents)"
    class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 pb-8">
    <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ "userInfo.callConsent" | translate }}
      </span>
    </div>
    <div class="flex items-center w-full sm:w-1/2 p-1">
      <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
        <p-dropdown
          appendTo="body"
          [options]="yesNoValues"
          [(ngModel)]="memberCopy.isSmsConsents"
          appendTo="body"
          [disabled]="
            !getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsSmsConsents, hasEndorsementWait4Sign)
          "
          [styleClass]="
            getDropdownClass(
              smsConsentHasChanged,
              getIsEditable(policyFieldsVM, PolicyFields.CLIENT, ClientFields.IsSmsConsents, hasEndorsementWait4Sign)
            ) + ' w-full'
          "
          (ngModelChange)="onSmsConsentHasChanged()"></p-dropdown>
      </div>
    </div>
  </div>
</div>
